export function getRandomInArray (array) {
    return array[Math.floor(Math.random() * array.length)]
}

export function createArray (length, value = null) {
    const result = []
    for (let i = length; i--;) {
        result.push(value)
    }
    return result
}

export function randomRange (min, max) {
    return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min) + 1)) + Math.ceil(min)
}

export function shuffleArray (array) {
    array.sort(() => Math.random() - 0.5);
}

export function generateString (len, charSet) {
    const symbols = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
        let randomPoz = Math.floor(Math.random() * symbols.length)
        randomString += symbols.substring(randomPoz, randomPoz + 1)
    }
    return randomString
}
